import { create } from '@fhs/zustand';

type PaymentFlowState =
  | 'idle'
  | 'encrypting'
  | 'insertRequested'
  | 'serviceModeCheck'
  | 'validatingCart'
  | 'committing'
  | 'vaulting'
  | 'success'
  | 'error';

export interface PaymentErrorInfo {
  code: string;
  message: string;
  canRetry: boolean;
}

export interface PaymentRetryInfo {
  canRetry: boolean;
  retryFromStep: string;
  errorCode: string;
  errorMessage: string;
  failedStep?: string;
}

export interface PaymentFlowStore {
  currentState: PaymentFlowState;
  retryInfo: PaymentRetryInfo | null;
  rbiOrderId: string | null;
  setRbiOrderId: (rbiOrderId: string | null) => void;
  setCurrentState: (state: PaymentFlowState) => void;
  setRetryInfo: (retryInfo: PaymentRetryInfo | null) => void;
  resetPaymentFlowStore: () => void;
}

const initialState = {
  currentState: 'idle' as PaymentFlowState,
  retryInfo: null,
  rbiOrderId: null,
};

export const usePaymentFlowStore = create<PaymentFlowStore>(set => ({
  ...initialState,
  setCurrentState: state => set({ currentState: state }),
  setRetryInfo: retryInfo => set({ retryInfo }),
  setRbiOrderId: rbiOrderId => set({ rbiOrderId }),
  // Reset to initial state
  resetPaymentFlowStore: () => set(initialState),
}));
